import { RegistrationFilePermissions } from '@zspace/roles';
import { useCallback } from 'react';
import { Element, Icon } from 'react-bulma-components';
import { FaDownload, FaShare } from 'react-icons/fa6';
import { environment } from '../../../environments/environment';
import CheckPermissions from '../../shared/check-permissions/check-permissions';
import Button from '../../ui/button/button';
import Link from '../../ui/link/link';
import Modal from '../../ui/modal/modal';

export type ActionsPendingModalProps = {
  show: boolean;
  id: string;
  onDownloadFileClick: (id: string) => void;
  onSendEmailClick: () => void;
  onCloseClick: () => void;
  isExecutingAction: boolean;
};

const TITLE = 'Registration file created';
const INFORMATIVE_TEXT =
  'Send this file to members of your organization to have them register devices without having to create a user for them. ';
const DOWNLOAD_BUTTON_TEXT = 'Download';
const SEND_BUTTON_TEXT = 'Send';

export function CreateRegistrationFileModal({
  show,
  id,
  onDownloadFileClick,
  onSendEmailClick,
  onCloseClick,
  isExecutingAction,
}: ActionsPendingModalProps) {
  const handleDownloadFileClick = useCallback(() => {
    onDownloadFileClick(id);
  }, [id, onDownloadFileClick]);

  return (
    <Modal
      show={show}
      className="modal-home"
      title={TITLE}
      titleClassName="mb-4"
    >
      <p className="is-size-7 py-2">
        {INFORMATIVE_TEXT}
        <Link color="primary" underlined to={environment.supportUrl} openNewTab>
          Learn more
        </Link>
      </p>
      <Element
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mt={8}
      >
        <Button color="primary-dark" outlined onClick={onCloseClick}>
          Close
        </Button>
        <div className="field is-grouped">
          <CheckPermissions
            permissions={
              RegistrationFilePermissions.REGISTRATION_FILES_DOWNLOAD
            }
          >
            <CheckPermissions.Render>
              <p className="control">
                <Button
                  color="primary-dark"
                  isExecutingAction={isExecutingAction}
                  onClick={handleDownloadFileClick}
                >
                  <Button.LoadingIcon icon={FaDownload} />
                  <span>{DOWNLOAD_BUTTON_TEXT}</span>
                </Button>
              </p>
            </CheckPermissions.Render>
          </CheckPermissions>
          <CheckPermissions
            permissions={RegistrationFilePermissions.REGISTRATION_FILES_SEND}
          >
            <CheckPermissions.Render>
              <p className="control">
                <Button color="primary-dark" onClick={onSendEmailClick}>
                  <Icon mr={2}>
                    <FaShare />
                  </Icon>
                  {SEND_BUTTON_TEXT}
                </Button>
              </p>
            </CheckPermissions.Render>
          </CheckPermissions>
        </div>
      </Element>
    </Modal>
  );
}

export default CreateRegistrationFileModal;
